import React, { useRef, useEffect } from 'react';

import { Button, ButtonSize, ButtonType, ButtonVariant } from 'components/Button';

import styles from './Finish.module.scss';

const Finish = () => {
  const scrollToRef = useRef(null);

  useEffect(() => {
    if (scrollToRef.current) {
      scrollToRef.current.scrollIntoView();
    }
  }, []);

  return (
    <div className={styles.root} ref={scrollToRef}>
      <div className={styles.top}>
        <h2 className={styles.title} style={{ paddingTop: 50 }}>
          Tack för din ansökan!
        </h2>
        <p>
          Du kan nu följa din <br />
          ansökan på Mitt Blipp
        </p>
        <Button
          type={ButtonType.Submit}
          variant={ButtonVariant.PrimaryMintSweet}
          size={ButtonSize.Large}
          href="/app/dashboard"
        >
          Mitt Blipp
        </Button>
      </div>
    </div>
  );
};
export default Finish;
